import './pageCard.scss'

const PageCard = ({ data }) => {
  return (
    <>
      {
        data.subName ?
          <div className='card h5'>
            <div className='title_name'>
              {data.name}
            </div>
            <div className='d-flex justify-content-around pt-2 text-white h6'>
              {
                data.subName.map((data, idx) => (
                  <div key={idx}>
                    <span>{data.title}</span>
                    <div className='card_value h5'>{data.value}</div>
                  </div>
                ))
              }
            </div>
          </div> :
          <div className='card h5'>
            <div className='title_name'>
              {data.name}
            </div>
            <div className='pt-4 card_value'>
              {data.value}
            </div>
          </div>
      }
    </>
  )
}

export default PageCard